import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-weight: bold;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 15px;
  color: #555555;
  padding-right: 5px;
`;

export const Paragraph = styled.span`
  line-height: 17px;
  color: #555555;
`;
